// @flow
/* globals global */
import configStageJson from './stage.json';
import configProdJson from './production.json';

if (typeof window === 'undefined') {
	global.window = {};
}

function getConfigQA(key: string) {
	// Set the config JSON for the associated environment
	if (!window.CONFIG_QA) {
		const ENV = window.ENV;
		switch (ENV) {
			case 'local':
				window.CONFIG_QA = configStageJson;
				break;
			case 'dev':
				window.CONFIG_QA = configStageJson;
				break;
			case 'stage':
				window.CONFIG_QA = configStageJson;
				break;
			case 'prod':
				window.CONFIG_QA = configProdJson;
				break;
			default:
				window.CONFIG_QA = configProdJson;
				console.error(`CChome-Apps: Didn't find window.ENV (${window.ENV}) - defaulting to prod`);
				break;
		}
	}

	return window.CONFIG_QA[key];
}

getConfigQA.config = window.CONFIG_QA;
getConfigQA.json = JSON.stringify(window.CONFIG_QA);

export default getConfigQA;
